import type { LocalizedDict } from '../index'
import type { AppearancePreference } from '../../lib/appearance'

type AppearanceStrings = {
  title: string
  description: string
  currentChoice: (choice: string) => string
  choices: Record<AppearancePreference, string>
  help: Record<AppearancePreference, string>
  saving: string
  saveFailed: string
  signInRequired: string
}

export const appearanceI18n: LocalizedDict<AppearanceStrings> = {
  en: {
    title: 'Appearance',
    description: 'Choose how PEXIFY looks on this account and your other devices.',
    currentChoice: (choice) => `Appearance: ${choice}`,
    choices: { system: 'System', light: 'Light', dark: 'Dark' },
    help: {
      system: 'Follow your device’s appearance setting.',
      light: 'Always use the light appearance.',
      dark: 'Always use the dark appearance.',
    },
    saving: 'Saving appearance…',
    saveFailed: 'Appearance was not saved. Please try again.',
    signInRequired: 'Your account is still loading. Try again in a moment.',
  },
  tr: {
    title: 'Görünüm',
    description: 'PEXIFY görünümünü bu hesap ve diğer cihazların için seç.',
    currentChoice: (choice) => `Görünüm: ${choice}`,
    choices: { system: 'Sistem', light: 'Açık', dark: 'Koyu' },
    help: {
      system: 'Cihazının görünüm ayarını takip eder.',
      light: 'Her zaman açık görünümü kullanır.',
      dark: 'Her zaman koyu görünümü kullanır.',
    },
    saving: 'Görünüm kaydediliyor…',
    saveFailed: 'Görünüm kaydedilemedi. Lütfen tekrar dene.',
    signInRequired: 'Hesabın yükleniyor. Birazdan tekrar dene.',
  },
}
